export default [
    {
        code : 'CODE_null',
        name : 'ทั่วไป',
        image : 'icon-other.png',
        type : 'DEFAULT',
    }
]